import axios from 'axios';
import axiosInstance from '../utils/axiosInstance';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getAllBlogs = () => {
  return axios
    .get(API_URL + 'blog/list', {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

const getBlogContent = ({ id }) => {
  return axios
    .get(API_URL + `blog/${id}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    });
};

const BlogService = { getAllBlogs, getBlogContent };
export default BlogService;
